export const figmaTheme = {
  primary: { dark: '#ff2da1', app: '#ff2da1d9', css: 'var(--f-primary)' },
  primaryHover: {
    dark: '#ff2da1d9',
    app: '#ff2da1',
    css: 'var(--f-primary-hover)',
  },
  primaryActive: {
    dark: '#ff2da1a6',
    app: '#ff2da1a6',
    css: 'var(--f-primary-active)',
  },
  secondary: { dark: '#2dff8bd9', app: '#2dff8bd9', css: 'var(--f-secondary)' },
  secondaryHover: {
    dark: '#2dff8b',
    app: '#2dff8b',
    css: 'var(--f-secondary-hover)',
  },
  secondaryActive: {
    dark: '#2dff8bd9',
    app: '#2dff8ba6',
    css: 'var(--f-secondary-active)',
  },
  text: { dark: '#ffffff', app: '#ffffff', css: 'var(--f-text)' },
  textSecondary: {
    dark: '#ffffffd9',
    app: '#ffffffd9',
    css: 'var(--f-text-secondary)',
  },
  textTertiary: {
    dark: '#ffffffa6',
    app: '#ffffffa6',
    css: 'var(--f-text-tertiary)',
  },
  textQuaternary: {
    dark: '#ffffff73',
    app: '#ffffff73',
    css: 'var(--f-text-quaternary)',
  },
  textDisabled: {
    dark: '#ffffff40',
    app: '#ffffff40',
    css: 'var(--f-text-disabled)',
  },
  textInvert: { dark: '#000000', app: '#000000', css: 'var(--f-text-invert)' },
  textInvertSecondary: {
    dark: '#000000bf',
    app: '#000000bf',
    css: 'var(--f-text-invert-secondary)',
  },
  bgBase: { dark: '#131216', app: '#313142', css: 'var(--f-bg-base)' },
  bgContainer: {
    dark: '#18171c',
    app: '#22222e',
    css: 'var(--f-bg-container)',
  },
  bgElevated: { dark: '#1e1c26', app: '#272735', css: 'var(--f-bg-elevated)' },
  border: { dark: '#ffffff33', app: '#3e3e4f', css: 'var(--f-border)' },
  bgMask: { dark: '#0d0d14f5', app: '#000000d6', css: 'var(--f-bg-mask)' },
  bgLayout: { dark: '#211e27', app: '#191921', css: 'var(--f-bg-layout)' },
  bgHover: { dark: '#292431', app: '#3e3e4f', css: 'var(--f-bg-hover)' },
  bgActive: { dark: '#2d2837', app: '#25252d', css: 'var(--f-bg-active)' },
  bgDisabled: {
    dark: '#00000038',
    app: '#00000038',
    css: 'var(--f-bg-disabled)',
  },
  other1: { dark: '#040404', app: '#040404', css: 'var(--f-other-1)' },
  other2: { dark: '#ffffff1a', app: '#ffffff1a', css: 'var(--f-other-2)' },
  other3: { dark: '#ffffff33', app: '#12111b', css: 'var(--f-other-3)' },
  other4: { dark: '#ffffff', app: '#ffffff', css: 'var(--f-other-4)' },
  other5: { dark: '#ffffff', app: '#000000a6', css: 'var(--f-other-5)' },
  other6: { dark: '#ffffff', app: '#00000073', css: 'var(--f-other-6)' },
  other7: { dark: '#ffffff', app: '#00000040', css: 'var(--f-other-7)' },
  other8: { dark: '#ffffff', app: '#ffffff0d', css: 'var(--f-other-8)' },
  other9: { dark: '#cac0e0', app: '#cac0e0', css: 'var(--f-other-9)' },
  other10: { dark: '#ece3ff', app: '#ece3ff', css: 'var(--f-other-10)' },
  primaryStyle1: {
    dark: '#ff2da11a',
    app: '#ff2da11a',
    css: 'var(--f-primary-style-1)',
  },
  primaryStyle2: {
    dark: '#ff2da140',
    app: '#ff2da140',
    css: 'var(--f-primary-style-2)',
  },
  primaryStyle3: {
    dark: '#ff2da173',
    app: '#ff2da173',
    css: 'var(--f-primary-style-3)',
  },
  primaryStyle4: {
    dark: '#ff2da1a6',
    app: '#ff2da1a6',
    css: 'var(--f-primary-style-4)',
  },
  primaryStyle5: {
    dark: '#ff2da1d9',
    app: '#ff2da1d9',
    css: 'var(--f-primary-style-5)',
  },
  primaryStyle6: {
    dark: '#ff2da1',
    app: '#ff2da1',
    css: 'var(--f-primary-style-6)',
  },
  primaryStyle7: {
    dark: '#ff2da1d9',
    app: '#ff2da1d9',
    css: 'var(--f-primary-style-7)',
  },
  primaryStyle8: {
    dark: '#ff2da1a6',
    app: '#ff2da1a6',
    css: 'var(--f-primary-style-8)',
  },
  secondaryStyle1: {
    dark: '#2dff8b26',
    app: '#2dff8b26',
    css: 'var(--f-secondary-style-1)',
  },
  secondaryStyle2: {
    dark: '#2dff8b40',
    app: '#2dff8b40',
    css: 'var(--f-secondary-style-2)',
  },
  secondaryStyle3: {
    dark: '#2dff8b73',
    app: '#2dff8b73',
    css: 'var(--f-secondary-style-3)',
  },
  secondaryStyle4: {
    dark: '#2dff8ba6',
    app: '#2dff8ba6',
    css: 'var(--f-secondary-style-4)',
  },
  secondaryStyle5: {
    dark: '#2dff8bd9',
    app: '#2dff8bd9',
    css: 'var(--f-secondary-style-5)',
  },
  secondaryStyle6: {
    dark: '#2dff8b',
    app: '#2dff8b',
    css: 'var(--f-secondary-style-6)',
  },
  secondaryStyle7: {
    dark: '#2dff8bd9',
    app: '#2dff8bd9',
    css: 'var(--f-secondary-style-7)',
  },
  secondaryStyle8: {
    dark: '#2dff8ba6',
    app: '#2dff8ba6',
    css: 'var(--f-secondary-style-8)',
  },
  blue1: { dark: '#ebf4ff', app: '#ebf4ff', css: 'var(--f-blue-1)' },
  blue2: { dark: '#c7e1ff', app: '#c7e1ff', css: 'var(--f-blue-2)' },
  blue3: { dark: '#a5ceff', app: '#a5ceff', css: 'var(--f-blue-3)' },
  blue4: { dark: '#71b2ff', app: '#71b2ff', css: 'var(--f-blue-4)' },
  blue5: { dark: '#3692ff', app: '#3692ff', css: 'var(--f-blue-5)' },
  blue6: { dark: '#2287ff', app: '#2287ff', css: 'var(--f-blue-6)' },
  blue7: { dark: '#0071f7', app: '#0071f7', css: 'var(--f-blue-7)' },
  green1: { dark: '#f1faec', app: '#f1faec', css: 'var(--f-green-1)' },
  green2: { dark: '#dcf3ce', app: '#dcf3ce', css: 'var(--f-green-2)' },
  green3: { dark: '#c0eaa8', app: '#c0eaa8', css: 'var(--f-green-3)' },
  green4: { dark: '#a4e181', app: '#a4e181', css: 'var(--f-green-4)' },
  green5: { dark: '#73d13d', app: '#73d13d', css: 'var(--f-green-5)' },
  green6: { dark: '#52c41a', app: '#52c41a', css: 'var(--f-green-6)' },
  green7: { dark: '#44aa12', app: '#44aa12', css: 'var(--f-green-7)' },
  yellow1: { dark: '#fff8e6', app: '#fff8e6', css: 'var(--f-yellow-1)' },
  yellow2: { dark: '#ffedbf', app: '#ffedbf', css: 'var(--f-yellow-2)' },
  yellow3: { dark: '#ffdf8c', app: '#ffdf8c', css: 'var(--f-yellow-3)' },
  yellow4: { dark: '#ffd059', app: '#ffd059', css: 'var(--f-yellow-4)' },
  yellow5: { dark: '#ffb700', app: '#ffb700', css: 'var(--f-yellow-5)' },
  yellow6: { dark: '#eeac00', app: '#eeac00', css: 'var(--f-yellow-6)' },
  yellow7: { dark: '#f7a300', app: '#f7a300', css: 'var(--f-yellow-7)' },
  orange1: { dark: '#ff9e451a', app: '#ff9e451a', css: 'var(--f-orange-1)' },
  orange2: { dark: '#ff9e4540', app: '#ff9e4540', css: 'var(--f-orange-2)' },
  orange3: { dark: '#ff9e4573', app: '#ff9e4573', css: 'var(--f-orange-3)' },
  orange4: { dark: '#ff9e45a6', app: '#ff9e45a6', css: 'var(--f-orange-4)' },
  orange5: { dark: '#ff9e45', app: '#ff9e45', css: 'var(--f-orange-5)' },
  orange6: { dark: '#ff8d24', app: '#ff8d24', css: 'var(--f-orange-6)' },
  orange7: { dark: '#f77803', app: '#f77803', css: 'var(--f-orange-7)' },
  red1: { dark: '#ffedee', app: '#ff4f511a', css: 'var(--f-red-1)' },
  red2: { dark: '#ffd3d3', app: '#ff4f5140', css: 'var(--f-red-2)' },
  red3: { dark: '#ffb0b1', app: '#ff4f5173', css: 'var(--f-red-3)' },
  red4: { dark: '#ff8d8e', app: '#ff4f51a6', css: 'var(--f-red-4)' },
  red5: { dark: '#ff4f51', app: '#ff4f51', css: 'var(--f-red-5)' },
  red6: { dark: '#f5222d', app: '#f5222d', css: 'var(--f-red-6)' },
  red7: { dark: '#cf1322', app: '#cf1322', css: 'var(--f-red-7)' },
  successBg: { dark: '#f1faec', app: '#f1faec', css: 'var(--f-success-bg)' },
  successBgHover: {
    dark: '#dcf3ce',
    app: '#dcf3ce',
    css: 'var(--f-success-bg-hover)',
  },
  successBorder: {
    dark: '#c0eaa8',
    app: '#c0eaa8',
    css: 'var(--f-success-border)',
  },
  successBorderHover: {
    dark: '#a4e181',
    app: '#a4e181',
    css: 'var(--f-success-border-hover)',
  },
  success: { dark: '#73d13d', app: '#73d13d', css: 'var(--f-success)' },
  successHover: {
    dark: '#52c41a',
    app: '#52c41a',
    css: 'var(--f-success-hover)',
  },
  successActive: {
    dark: '#44aa12',
    app: '#44aa12',
    css: 'var(--f-success-active)',
  },
  warningBg: { dark: '#fff8e6', app: '#fff8e6', css: 'var(--f-warning-bg)' },
  warningBgHover: {
    dark: '#ffedbf',
    app: '#ffedbf',
    css: 'var(--f-warning-bg-hover)',
  },
  warningBorder: {
    dark: '#ffdf8c',
    app: '#ffdf8c',
    css: 'var(--f-warning-border)',
  },
  warningBorderHover: {
    dark: '#ffd059',
    app: '#ffd059',
    css: 'var(--f-warning-border-hover)',
  },
  warning: { dark: '#ffb700', app: '#ffb700', css: 'var(--f-warning)' },
  warningHover: {
    dark: '#eeac00',
    app: '#eeac00',
    css: 'var(--f-warning-hover)',
  },
  warningActive: {
    dark: '#f7a300',
    app: '#f7a300',
    css: 'var(--f-warning-active)',
  },
  errorBg: { dark: '#ffedee', app: '#ff4f511a', css: 'var(--f-error-bg)' },
  errorBgHover: {
    dark: '#ffd3d3',
    app: '#ff4f5140',
    css: 'var(--f-error-bg-hover)',
  },
  errorBorder: {
    dark: '#ffb0b1',
    app: '#ff4f5173',
    css: 'var(--f-error-border)',
  },
  errorBorderHover: {
    dark: '#ff8d8e',
    app: '#ff4f51a6',
    css: 'var(--f-error-border-hover)',
  },
  error: { dark: '#ff4f51', app: '#ff4f51', css: 'var(--f-error)' },
  errorHover: { dark: '#f5222d', app: '#f5222d', css: 'var(--f-error-hover)' },
  borderHover: {
    dark: '#ffffff7a',
    app: '#4f4f5f',
    css: 'var(--f-border-hover)',
  },
  borderActive: {
    dark: '#202029',
    app: '#202029',
    css: 'var(--f-border-active)',
  },
  borderSecondary: {
    dark: '#4c4c4c80',
    app: '#2f2f3d',
    css: 'var(--f-border-secondary)',
  },
  errorActive: {
    dark: '#cf1322',
    app: '#cf1322',
    css: 'var(--f-error-active)',
  },
}
